import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What does technology consulting involve, and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Technology consulting involves providing expert advice and guidance to businesses on how to use technology to solve problems, improve efficiency, and achieve their goals. A technology consultant can help businesses identify and assess their technology needs, develop and implement technology solutions, and provide ongoing support and maintenance. Technology consulting can be a valuable resource for businesses looking to stay ahead of the curve and remain competitive.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What types of services does a technology consultant typically offer?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Technology consultants typically offer a range of services, including technology strategy development, system and application design and development, project management, and IT support and maintenance. A technology consultant can also help businesses to select and implement appropriate software and hardware solutions and to optimize their use of technology to maximize productivity and efficiency.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help me with my technology consulting needs?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced technology consultants who are well-equipped to help businesses of all sizes with their technology consulting needs. We have a track record of success in helping businesses to identify and assess their technology needs, develop and implement technology solutions, and optimize their use of technology to drive growth and success. We offer a range of services and pricing options to fit different budgets and needs, and we are always available to provide ongoing support and maintenance as needed.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;